import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';

export const LayoutGrid = memo(({ children, style, ...rest }) => {
  const { styles } = useStyle();
  return (
    <View style={[styles.container, style]} {...rest}>
      <View style={styles.column1}>{children[0]}</View>
      <Space size={40} />
      <View style={styles.column2}>{children[1]}</View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  column1: {
    flex: 2,
  },
  column2: {
    flex: 3,
  },
}));
